/**
 * @module app.um
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DiagnosisFlagReloadEvent } from 'app/um/lib/events';
import { AuthService } from 'app/um/services/auth-service';
import { forceNull } from 'app/shared/lib/utilities';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class SaveDiagnosisFlag extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'reset' })
    public diagnosisFlag: UM.AuthFlag = {};

    protected description: string = '';
    protected code: string = '';
    protected displayInPortal: boolean = false;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AuthService,
        private readonly toaster: Toaster,
        private readonly events: EventAggregator,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    public async reset(): Promise<void> {
        this.description = this.diagnosisFlag.description || '';
        this.code = this.diagnosisFlag.code || '';
        this.displayInPortal = this.diagnosisFlag.flag?.displayInPortal || false;
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return await this.saveDiagnosisFlag();
    }

    protected buildDiagnosisFlag(): UM.AuthFlag {
        return {
            id: this.diagnosisFlag.id,
            description: this.description,
            code: forceNull(this.code),
            flag: {
                allowsDiagnoses: true,
                displayInPortal: this.displayInPortal
            }
        };
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    protected async saveDiagnosisFlag(): Promise<boolean> {
        let isSuccessful = false;
        try {
            this.state.beginSave();
            const response = await this.service.saveAuthFlag(this.buildDiagnosisFlag());
            isSuccessful = response.isSuccessful;
            this.events.publish(new DiagnosisFlagReloadEvent());
        }
        catch(error) {
            throw error;
        }
        finally {
            this.toaster.standard.saved('um:auth.flag.diagnosisFlag.$', isSuccessful);
            this.state.endSave();
            return isSuccessful;
        }
    }
}
